export const RadioButton = (props) => {
    const { value, name, text } = props;
    
    return (
        <>
            <input type="radio" name={name} value={value} />
            {text}
        </>
    );
}